import { Switch } from "antd";

export default function DBSwitch(props) {
    return <Switch {...props} />;
}
